var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "row service-bg" }, [
    _c("div", { staticClass: "col" }, [
      _vm._m(0),
      _c("div", { staticClass: "service-content" }, [
        _c("span", [_vm._v(_vm._s(_vm.item.service.name))])
      ])
    ]),
    _c("div", { staticClass: "col" }, [
      _vm._m(1),
      _c("div", { staticClass: "service-content" }, [
        _c("span", [_vm._v(" " + _vm._s(_vm.item.frequency) + " ")])
      ])
    ]),
    _c("div", { staticClass: "col" }, [
      _vm._m(2),
      _c("div", { staticClass: "service-content" }, [
        _c("span", [_vm._v(_vm._s(_vm._f("price")(_vm.item.cost)))])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "service-title" }, [
      _c("span", [_vm._v("Servicio:")])
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "service-title" }, [
      _c("span", [_vm._v("Frecuencia:")])
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "service-title" }, [
      _c("span", [_vm._v("Costo:")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }